import { Map as ImmutableMap, Record } from 'immutable';
const SiteSettingsRecord = Record({
  bodyOverrideByDomain: ImmutableMap()
});
const DomainSettingsRecord = Record({
  membershipSsoEnabled: null,
  membershipJwtEnabled: null,
  membershipSocialAuthEnabled: null
});
SiteSettingsRecord.fromJS = attrs => {
  const bodyOverrideByDomain = Object.keys(attrs.bodyOverrideByDomain).reduce((domainSettings, domain) => domainSettings.set(domain, new DomainSettingsRecord(attrs.bodyOverrideByDomain[domain])), ImmutableMap());
  return new SiteSettingsRecord({
    bodyOverrideByDomain
  });
};
export default SiteSettingsRecord;